export default {"id":"d8973db0","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}